import {Account} from "@toolpad/core/Account";
import {AppProvider, type Session} from "@toolpad/core/AppProvider";
import ResetPasswordDialog from "auth/ResetPasswordDialog";
import {useAuth, useAuthenticatedUser} from "hooks/useAuth";
import TopUpAccountDialog from "pages/dashboard/TopUpAccountDialog";
import {type FC, useCallback, useMemo, useState} from "react";
import Menu from "./Menu";

const AccountMenu: FC = () => {
  const user = useAuthenticatedUser();
  const {clearUser} = useAuth();

  const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
  const [topUpOpen, setTopUpOpen] = useState(false);

  const session = useMemo<Session | null>(() => {
    if (!user) return null;

    return {
      user: {
        id: String(user.id),
        name: user.full_name ?? user.email,
        email: user.phone,
      },
    };
  }, [user]);

  const authentication = useMemo(
    () => ({
      signIn: () => {},
      signOut: clearUser,
    }),
    [clearUser],
  );

  const popoverContent = useCallback(
    () => (
      <Menu
        handleOpenResetPassword={() => setResetPasswordOpen(true)}
        handleOpenTopUp={() => setTopUpOpen(true)}
      />
    ),
    [user],
  );

  return (
    <AppProvider authentication={authentication} session={session}>
      <Account slots={{popoverContent}} />

      <ResetPasswordDialog
        open={resetPasswordOpen}
        onClose={() => setResetPasswordOpen(false)}
      />

      <TopUpAccountDialog
        open={topUpOpen}
        onClose={() => setTopUpOpen(false)}
      />
    </AppProvider>
  );
};

export default AccountMenu;
